.late {
  background-color: var(--color-feedback-warning-400);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.xsm {
  width: 16px;
  height: 16px;
}

.sm {
  width: 19px;
  height: 19px;
}

.lg {
  width: 33.8169px;
  height: 33.8169px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FnZW50L193b3JrLzE0L3Mvc2VudGluZWwtZnJvbnQvc3JjL2NvbW1vbi9mcmFnbWVudHMiLCJzb3VyY2VzIjpbIkxhdGVJY29uLm1vZHVsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTtFQUVBO0VBQ0E7RUFDQTtFQUVBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLmxhdGUge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1jb2xvci1mZWVkYmFjay13YXJuaW5nLTQwMCk7XG4gIGNvbG9yOiAjZmZmZmZmO1xuXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuXG4gIGJvcmRlci1yYWRpdXM6IDUwJTtcbn1cblxuLnhzbSB7XG4gIHdpZHRoOiAxNnB4O1xuICBoZWlnaHQ6IDE2cHg7XG59XG5cbi5zbSB7XG4gIHdpZHRoOiAxOXB4O1xuICBoZWlnaHQ6IDE5cHg7XG59XG5cbi5sZyB7XG4gIHdpZHRoOiAzMy44MTY5cHg7XG4gIGhlaWdodDogMzMuODE2OXB4O1xufSJdfQ== */